



















































































import { Vue, Component, Prop } from "vue-property-decorator";
import api from "@/lib/Api";
const Tabulator = require("tabulator-tables");
const Url = require("url");

@Component({})
export default class TabulatorComponent extends Vue {
  @Prop() options?: any;
  @Prop({ required: true }) columns?: any[];

  @Prop({ required: true }) apiController?: string;

  filter: string = "";
  viewCount: number = 10;
  totalCount: number = 0;

  constructor() {
    super();
  }

  table: any;

  readonly locals: any = {
    de: {
      ajax: {
        loading: "Lade",
        error: "Fehler"
      },
      groups: {
        item: "Item",
        items: "Items"
      },
      pagination: {
        first: `<i class="fa fa-angle-double-left"></i>`,
        first_title: "Erste Seite",
        last: `<i class="fa fa-angle-double-right"></i>`,
        last_title: "Letzte Seite",
        prev: `<i class="fa fa-angle-left"></i>`,
        prev_title: "Vorherige Seite",
        next: `<i class="fa fa-angle-right"></i>`,
        next_title: "Nächste Seite"
      }
    }
  };

  created() {
    this.$on("reloadTable", () => this.updateTable());
  }

  getApiController() {
    let val = this.apiController || "";
    val = val.startsWith("/") ? val : "/" + val;
    val = val.endsWith("/") ? val.substring(0, val.length - 1) : val;
    return val;
  }

  private ajaxProxy(url: any, config: any, params: any) {
    const that = this;
    return new Promise(function(resolve, reject) {
      api
        .get(that.getApiController() + "/list", {
          params: {
            filterText: that.filter,
            tb: JSON.stringify(params)
          }
        })
        .then(data => {
          // data.data.data = data.data.data.map((x: any) => {
          //   // x._Actions = `<button class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>`;
          //   return x;
          // });
          resolve(data.data);
        })
        .catch(err => {
          reject(err);
        });
    }).then((data: any) => {
      this.totalCount = (data.total as number) ?? 0;
      return data;
    });
  }

  private openModal(id?: number) {
    this.$emit("showModal", id ?? 0);
  }

  private deleteCellFormatter(
    cell: any,
    formatterParams: any,
    onRendered: any
  ) {
    return `<button class="btn btn-sm btn-danger delete-action"><i class="fa fa-trash"></i></button>`;
  }

  private cellClick(e: MouseEvent, row: any) {
    // console.log(e);
    const eles = (e as any)?.path as Array<Element>;
    if (!eles) return;

    let container = undefined;
    let btn = undefined;
    for (let i = 0; i < eles.length; i++) {
      if (eles[i].classList.contains("tabulator-cell")) {
        btn = i > 0 ? eles[i - 1] : eles[i];
        container = eles[i];
        break;
      }
    }

    if (!container || !btn) return;
    for (const c of container.children as Iterable<Element>) {
      if (btn == c) {
        e.preventDefault();
        const data = row.getData();
        if (c.classList.contains("delete-action")) {
          if (confirm(`${data.Name ?? data.Id} löschen?`)) {
            api.delete("/manage/group/d/" + data.Id).then(res => {
              this.table.deleteRow(data.Id);
              Vue.toasted.success("Gelöscht");
            });
            // console.log("Delete ", row.getData().Id);
          }
        }
      }
    }
  }

  viewCountChange(e: Event) {
    // console.log(this.viewCount);
    this.table.setPageSize(this.viewCount);
  }

  downloadContent(e: Event) {
    this.table.download("csv", "data.csv");
  }

  readonly defaultOptions = {
    height: "auto",
    layout: "fitDataStretch",

    locale: "de",
    langs: this.locals,

    index: "Id",
    columns: [
      ...(this.columns as Array<any>),
      {
        title: "",
        formatter: this.deleteCellFormatter,
        headerSort: false,
        hozAlign: "right",
        cellClick: this.cellClick
      }
    ],
    rowDblClick: (e: any, row: any) =>
      this.openModal(row.getData().Id as number),

    pagination: "remote",
    paginationSize: this.viewCount,
    // footerElement: this.$refs["table-footer"], //"<i class='fa fa-trash'></i>",

    ajaxURL: api.defaults.baseURL,
    ajaxFiltering: true,
    ajaxSorting: true,

    initialSort: [{ column: "Id", dir: "asc" }],

    placeholder: "Keine Daten vorhanden",

    ajaxRequestFunc: this.ajaxProxy,
    ajaxLoaderLoading: `<div title='Loading' style='background-image: url("${require("@/assets/loading.svg")}"); background-repeat: no-repeat; height: 20px; width: 150px;'/>`
  };

  public updateTable(ev?: any) {
    if (ev) ev.preventDefault();
    this.table?.replaceData();
  }

  private mounted() {
    this.table = new Tabulator(this.$refs.tabulatorTable, {
      ...this.defaultOptions,
      ...this.options
    });
    (window as any).yeet = this.table;
  }
}
